import Typo from './Typo'

export { default as HeroTitle } from './HeroTitle'
export { default as Title } from './Title'
export { default as Label } from './Label'
export { default as Text } from './Text'
export { default as RichText } from './RichText'

export default Typo
